import { stripHtmlTags } from 'utils/stripHtmlTags';

const renderValues = (value: any[]) => (
  <>
    {value?.map((item, index) => (
      <div key={index}>
        <strong>{index + 1}.</strong> {String(item ?? '-')}
      </div>
    ))}
  </>
);
export const controlInventoryReportColumns = (data: any[] = []) => {
  const hasValue = (field: string) =>
    data.some(
      (item) =>
        item?.[field] !== null &&
        item?.[field] !== undefined &&
        item?.[field] !== ''
    );

  const organizationalColumns = [
    {
      title: 'Group',
      dataIndex: 'group_name',
      key: 'group_name',
      width: 180
    },
    {
      title: 'Division',
      dataIndex: 'division_name',
      key: 'division_name',
      width: 180
    },
    {
      title: 'Region',
      dataIndex: 'region_name',
      key: 'region_name',
      width: 180
    },
    {
      title: 'Legal entity',
      dataIndex: 'legal_entity_name',
      key: 'legal_entity_name',
      width: 180
    },
    {
      title: 'Business unit',
      dataIndex: 'business_unit_name',
      key: 'business_unit_name',
      width: 180
    }
  ].filter((column) => hasValue(column.dataIndex));

  return [
    ...organizationalColumns,
    {
      title: 'Control',
      dataIndex: 'control_name',
      key: 'control_name',
      width: 200
    },
    {
      title: 'Control Description',
      dataIndex: 'control_description',
      key: 'control_description',
      width: 250
    },
    {
      title: 'Control Objective',
      dataIndex: 'control_objective',
      key: 'control_objective',
      width: 200
    },
    {
      title: 'Key Control',
      dataIndex: 'key_control',
      key: 'key_control',
      width: 120,
      render: (value: boolean | null) => (value ? 'true' : 'false')
    },
    {
      title: 'Control Type',
      dataIndex: 'control_type',
      key: 'control_type',
      width: 120
    },
    {
      title: 'Control Nature',
      dataIndex: 'control_nature',
      key: 'control_nature',
      width: 120
    },
    {
      title: 'Control Frequency',
      dataIndex: 'control_frequency',
      key: 'control_frequency',
      width: 120
    },
    // {
    //   title: 'Control Level',
    //   dataIndex: 'control_level',
    //   key: 'control_level',
    //   width: 120
    // },
    // {
    //   title: (
    //     <ControlReportStyled.ControlReportValidityHeaderWrapper>
    //       Control validity from - to
    //     </ControlReportStyled.ControlReportValidityHeaderWrapper>
    //   ),
    //   key: 'control_validity',
    //   onHeaderCell: () => ({
    //     style: ControlReportStyled.controlReportHeaderStyle
    //   }),
    //   children: [
    //     {
    //       title: '',
    //       dataIndex: 'control_start_date',
    //       key: 'control_start_date',
    //       width: 120,
    //       onHeaderCell: () => ({
    //         style: ControlReportStyled.controlReportDateHeaderStyle
    //       }),
    //       onCell: () => ({
    //         style: ControlReportStyled.controlReportStartDateCellStyle
    //       })
    //     },
    //     {
    //       title: '',
    //       dataIndex: 'control_end_date',
    //       key: 'control_end_date',
    //       width: 120,
    //       onHeaderCell: () => ({
    //         style: ControlReportStyled.controlReportDateHeaderStyle
    //       })
    //     }
    //   ]
    // },
    {
      title: 'Control Origin',
      dataIndex: 'control_origin_name',
      key: 'control_origin_name',
      width: 150
    },
    {
      title: 'Status',
      dataIndex: 'instance_control_status_name',
      key: 'instance_control_status_name',
      width: 120
    },
    {
      title: 'Owner',
      dataIndex: 'owner_name',
      key: 'owner_name',
      width: 150
    },
    {
      title: 'Control Performer',
      dataIndex: 'control_performer_name',
      key: 'control_performer_name',
      width: 150
    },
    {
      title: 'Risk Control Evidence',
      dataIndex: 'risk_control_evidence_name',
      key: 'risk_control_evidence_name',
      width: 180
    },
    {
      title: 'Control Prerequisites',
      dataIndex: 'control_prerequisites_name',
      key: 'control_prerequisites_name',
      width: 180
    },
    {
      title: 'Monitoring Level',
      dataIndex: 'monitoring_level',
      key: 'monitoring_level',
      width: 150
    },
    // {
    //   title: 'Control Instance Description',
    //   dataIndex: 'control_instance_description_1',
    //   key: 'control_instance_description_1',
    //   width: 250
    // },
    // {
    //   title: 'Control Instance Description 2',
    //   dataIndex: 'control_instance_description_2',
    //   key: 'control_instance_description_2',
    //   width: 250
    // },
    {
      title: 'Control Overall Effectiveness',
      dataIndex: 'control_instance_control_overall_effectiveness_name',
      key: 'control_instance_control_overall_effectiveness_name',
      width: 200
    },
    {
      title: 'Risk',
      dataIndex: 'risk_name',
      key: 'risk_name',
      width: 180
    },
    {
      title: 'Business Process',
      dataIndex: 'business_process_l4_name',
      key: 'business_process_l4_name',
      width: 180
    }
  ];
};
export const controlDesignEffectivenessReportColumns = (data: any[] = []) => {
  const hasValue = (field: string) =>
    data.some(
      (item) =>
        item?.[field] !== null &&
        item?.[field] !== undefined &&
        item?.[field] !== ''
    );

  const organizationalColumns = [
    {
      title: 'Group name',
      dataIndex: 'group_name',
      key: 'group_name',
      width: 180
    },
    {
      title: 'Division name',
      dataIndex: 'division_name',
      key: 'division_name',
      width: 180
    },
    {
      title: 'Region name',
      dataIndex: 'region_name',
      key: 'region_name',
      width: 180
    },
    {
      title: 'Legal entity name',
      dataIndex: 'legal_entity_name',
      key: 'legal_entity_name',
      width: 180
    },
    {
      title: 'Business unit name',
      dataIndex: 'business_unit_name',
      key: 'business_unit_name',
      width: 180
    }
  ].filter((column) => hasValue(column.dataIndex));

  return [
    ...organizationalColumns,
    {
      title: 'Control',
      dataIndex: 'control_name',
      key: 'control_name',
      width: 200
    },
    {
      title: 'Control Description',
      dataIndex: 'control_description',
      key: 'control_description',
      width: 250
    },
    {
      title: 'Testing Method',
      dataIndex: 'testing_method_name',
      key: 'testing_method_name',
      width: 150
    },
    {
      title: 'Test Type',
      dataIndex: 'test_type_name',
      key: 'test_type_name',
      width: 120
    },
    {
      title: 'Design Effectiveness',
      dataIndex: 'instance_design_effectiveness_name',
      key: 'instance_design_effectiveness_name',
      width: 150
    },
    {
      title: 'Performer ToD',
      dataIndex: 'performer_tod_name',
      key: 'performer_tod_name',
      width: 150
    },
    {
      title: 'Approver',
      dataIndex: 'approver_name',
      key: 'approver_name',
      width: 150
    },
    {
      title: 'Test Objectiveness',
      dataIndex: 'test_objectiveness_name',
      key: 'test_objectiveness_name',
      width: 150
    },
    {
      title: 'Last Test Date Design',
      dataIndex: 'last_test_date_design',
      key: 'last_test_date_design',
      width: 150
    },
    {
      title: 'Test Description',
      dataIndex: 'test_description_2',
      key: 'test_description_2',
      width: 200
    },
    {
      title: 'Evidence Description',
      dataIndex: 'evidence_description',
      key: 'evidence_description',
      width: 200
    }
  ];
};
export const controlOperationaleffectivenessReportColumns = (
  data: any[] = []
) => {
  const hasValue = (field: string) =>
    data.some(
      (item) =>
        item?.[field] !== null &&
        item?.[field] !== undefined &&
        item?.[field] !== ''
    );

  const organizationalColumns = [
    {
      title: 'Group name',
      dataIndex: 'group_name',
      key: 'group_name',
      width: 180
    },
    {
      title: 'Division name',
      dataIndex: 'division_name',
      key: 'division_name',
      width: 180
    },
    {
      title: 'Region name',
      dataIndex: 'region_name',
      key: 'region_name',
      width: 180
    },
    {
      title: 'Legal entity name',
      dataIndex: 'legal_entity_name',
      key: 'legal_entity_name',
      width: 180
    },
    {
      title: 'Business unit name',
      dataIndex: 'business_unit_name',
      key: 'business_unit_name',
      width: 180
    }
  ].filter((column) => hasValue(column.dataIndex));

  return [
    ...organizationalColumns,
    {
      title: 'Control',
      dataIndex: 'control_name',
      key: 'control_name',
      width: 200
    },
    {
      title: 'Control Description',
      dataIndex: 'control_description',
      key: 'control_description',
      width: 250
    },
    {
      title: 'Operating Effectiveness',
      dataIndex: 'instance_operating_effectiveness_name',
      key: 'instance_operating_effectiveness_name',
      width: 170
    },
    {
      title: 'Performer ToE',
      dataIndex: 'performer_toe_name',
      key: 'performer_toe_name',
      width: 150
    },
    {
      title: 'Test Objectiveness',
      dataIndex: 'test_objectiveness_2_name',
      key: 'test_objectiveness_2_name',
      width: 150
    },
    {
      title: 'Test Result',
      dataIndex: 'test_result_name',
      key: 'test_result_name',
      width: 120
    },
    {
      title: 'Evidence Type',
      dataIndex: 'evidence_type_name',
      key: 'evidence_type_name',
      width: 150
    },
    {
      title: 'Last Test Date Operational',
      dataIndex: 'last_test_date_operational',
      key: 'last_test_date_operational',
      width: 180
    },
    {
      title: 'Next Test Date',
      dataIndex: 'next_test_date',
      key: 'next_test_date',
      width: 150
    },
    {
      title: 'Test Description',
      dataIndex: 'test_description',
      key: 'test_description',
      width: 200
    },
    {
      title: 'Evidence Description',
      dataIndex: 'evidence_description_2',
      key: 'evidence_description_2',
      width: 200
    }
  ];
};

export const BUSINESS_RULES_AUDIT_FINDINGS_COLUMNS = [
  {
    title: 'Parent',
    dataIndex: 'parent_key',
    key: 'parent_key',
    width: 100
  },
  {
    title: 'Child',
    dataIndex: 'child_key',
    key: 'child_key',
    width: 100
  },
  {
    title: 'Key',
    dataIndex: 'bru_key_value',
    key: 'bru_key_value',
    width: 120
  },
  {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
    width: 300
  },
  {
    title: 'Industry',
    dataIndex: 'ind_name',
    key: 'ind_name',
    width: 150
  },
  {
    title: 'Module',
    dataIndex: 'mod_name',
    key: 'mod_name',
    width: 120
  },
  {
    title: 'Category',
    dataIndex: 'cat_name',
    key: 'cat_name',
    width: 120
  },
  {
    title: 'Level',
    dataIndex: 'level',
    key: 'level',
    width: 80
  },
  {
    title: 'Applicable',
    dataIndex: 'is_app',
    key: 'is_app',
    width: 100
  },
  {
    title: 'Gap Description',
    dataIndex: 'gap_desc',
    key: 'gap_desc',
    width: 300,
    render: (items: string[]) => (
      <>
        {items?.map((item, index) => (
          <div key={index}>
            <strong>{index + 1}.</strong> {stripHtmlTags(String(item ?? '-'))}
          </div>
        ))}
      </>
    )
  },
  {
    title: 'Gap Due Date',
    dataIndex: 'gap_due_date',
    key: 'gap_due_date',
    width: 150,
    render: renderValues
  },
  {
    title: 'Gap Closed',
    dataIndex: 'gap_closed',
    key: 'gap_closed',
    width: 120,
    render: renderValues
  },
  {
    title: 'Gap Priority',
    dataIndex: 'gap_priority',
    key: 'gap_priority',
    width: 150,
    render: renderValues
  },
  {
    title: 'Gap Source',
    dataIndex: 'gap_source',
    key: 'gap_source',
    width: 150,
    render: renderValues
  },
  {
    title: 'Gap Owner',
    dataIndex: 'gap_owner_mail',
    key: 'gap_owner_mail',
    width: 250,
    render: renderValues
  },
  {
    title: 'Gap Created On',
    dataIndex: 'gap_created_on',
    key: 'gap_created_on',
    width: 150,
    render: renderValues
  },
  {
    title: 'Gap Noticed',
    dataIndex: 'gap_noticed',
    key: 'gap_noticed',
    width: 150,
    render: renderValues
  },
  {
    title: 'Gap Owner Notified',
    dataIndex: 'gap_owner_notified',
    key: 'gap_owner_notified',
    width: 180,
    render: renderValues
  }
];

export const BRU_EVIDENCES_COLUMNS = [
  {
    title: 'Parent',
    dataIndex: 'parent_key',
    key: 'parent_key',
    width: 100
  },
  {
    title: 'Child',
    dataIndex: 'child_key',
    key: 'child_key',
    width: 100
  },
  {
    title: 'Key',
    dataIndex: 'bru_key_value',
    key: 'bru_key_value',
    width: 120
  },
  {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
    width: 300
  },
  {
    title: 'Industry',
    dataIndex: 'ind_name',
    key: 'ind_name',
    width: 150
  },
  {
    title: 'Module',
    dataIndex: 'mod_name',
    key: 'mod_name',
    width: 120
  },
  {
    title: 'Category',
    dataIndex: 'cat_name',
    key: 'cat_name',
    width: 120
  },
  {
    title: 'Level',
    dataIndex: 'level',
    key: 'level',
    width: 80
  },
  {
    title: 'Applicable',
    dataIndex: 'is_app',
    key: 'is_app',
    width: 100
  },
  {
    title: 'Evidence Description',
    dataIndex: 'evd_description',
    key: 'evd_description',
    width: 300,
    render: (items: string[]) => (
      <>
        {items?.map((item, index) => (
          <div key={index}>
            <strong>{index + 1}.</strong> {stripHtmlTags(String(item ?? '-'))}
          </div>
        ))}
      </>
    )
  },
  {
    title: 'Evidence Approved',
    dataIndex: 'evd_approved',
    key: 'evd_approved',
    width: 150,
    render: renderValues
  },
  {
    title: 'Evidence Approver',
    dataIndex: 'evd_approver_name',
    key: 'evd_approver_name',
    width: 250,
    render: renderValues
  },
  {
    title: 'Evidence Reviewed',
    dataIndex: 'evd_reviewed',
    key: 'evd_reviewed',
    width: 150,
    render: renderValues
  },
  {
    title: 'Evidence Reviewer',
    dataIndex: 'evd_reviewer_name',
    key: 'evd_reviewer_name',
    width: 250,
    render: renderValues
  },
  {
    title: 'Evidence Valid From',
    dataIndex: 'evd_valid_from',
    key: 'evd_valid_from',
    width: 150,
    render: renderValues
  },
  {
    title: 'Evidence Valid To',
    dataIndex: 'evd_valid_to',
    key: 'evd_valid_to',
    width: 150,
    render: renderValues
  },
  {
    title: 'Solution Description',
    dataIndex: 'evd_sol_desc',
    key: 'evd_sol_desc',
    width: 300,
    render: (items: string[]) => (
      <>
        {items?.map((item, index) => (
          <div key={index}>
            <strong>{index + 1}.</strong> {stripHtmlTags(String(item ?? '-'))}
          </div>
        ))}
      </>
    )
  }
];

export const BRU_GAPS_AUDITS_SOLUTIONS_COLUMNS = [
  {
    title: 'Gap Description',
    dataIndex: 'gap_description',
    key: 'gap_description',
    width: 250,
    render: (text: string) => <div>{stripHtmlTags(text)}</div>
  },
  {
    title: 'Gap Due Date',
    dataIndex: 'gap_due_date',
    key: 'gap_due_date',
    width: 120
  },
  {
    title: 'Gap Priority',
    dataIndex: 'priority_name',
    key: 'priority_name',
    width: 100
  },
  {
    title: 'Gap Owner',
    dataIndex: 'owner_name',
    key: 'owner_name',
    width: 180
  },
  {
    title: 'Gap Closed',
    dataIndex: 'gap_closed',
    key: 'gap_closed',
    width: 80
  },
  {
    title: 'Gap Created On',
    dataIndex: 'gap_created_on',
    key: 'gap_created_on',
    width: 120
  },
  {
    title: 'Industry',
    dataIndex: 'ind_name',
    key: 'ind_name',
    width: 150
  },
  {
    title: 'BRU key',
    dataIndex: 'bru_key_value',
    key: 'bru_key_value',
    width: 120
  },
  {
    title: 'Group',
    dataIndex: 'grp_name',
    key: 'grp_name',
    width: 120
  },
  {
    title: 'Module',
    dataIndex: 'mod_name',
    key: 'mod_name',
    width: 120
  },
  {
    title: 'Category',
    dataIndex: 'cat_name',
    key: 'cat_name',
    width: 120
  },
  {
    title: 'Source',
    dataIndex: 'source_name',
    key: 'source_name',
    width: 100
  },
  {
    title: 'Solution approved',
    dataIndex: 'sol_approved',
    key: 'sol_approved',
    width: 150,
    render: renderValues
  },
  {
    title: 'Solution approver',
    dataIndex: 'sol_approver_name',
    key: 'sol_approver_name',
    width: 200,
    render: renderValues
  },
  {
    title: 'Solution approver notified',
    dataIndex: 'sol_approver_notified',
    key: 'sol_approver_notified',
    width: 180,
    render: renderValues
  },
  {
    title: 'Solution Description',
    dataIndex: 'sol_description',
    key: 'sol_description',
    width: 300,
    render: (items: string[]) => (
      <>
        {items?.map((item, index) => (
          <div key={index}>
            <strong>{index + 1}.</strong> {stripHtmlTags(String(item ?? '-'))}
          </div>
        ))}
      </>
    )
  },
  {
    title: 'Solution evidence required',
    dataIndex: 'sol_evd_required',
    key: 'sol_evd_required',
    width: 180,
    render: renderValues
  },
  {
    title: 'Solution reviewed',
    dataIndex: 'sol_reviewed',
    key: 'sol_reviewed',
    width: 150,
    render: renderValues
  },
  {
    title: 'Solution reviewer',
    dataIndex: 'sol_reviewer_name',
    key: 'sol_reviewer_name',
    width: 200,
    render: renderValues
  },
  {
    title: 'Solution reviewer notified',
    dataIndex: 'sol_reviewer_notified',
    key: 'sol_reviewer_notified',
    width: 180,
    render: renderValues
  },
  {
    title: 'Solution type name',
    dataIndex: 'sol_type_name',
    key: 'sol_type_name',
    width: 180,
    render: renderValues
  }
];

export const SOLUTIONS_TASKS_COLUMNS = [
  {
    title: 'BRU ID',
    dataIndex: 'bru_id',
    key: 'bru_id',
    width: 100
  },
  {
    title: 'BRU Value',
    dataIndex: 'bru_value',
    key: 'bru_value',
    width: 250,
    render: (text: string) => <div>{stripHtmlTags(text)}</div>
  },
  {
    title: 'Solution ID',
    dataIndex: 'sol_id',
    key: 'sol_id',
    width: 100
  },
  {
    title: 'Solution Description',
    dataIndex: 'solution_description',
    key: 'solution_description',
    width: 250,
    render: (text: string) => <div>{stripHtmlTags(text)}</div>
  },
  {
    title: 'Solution Type',
    dataIndex: 'solution_type_name',
    key: 'solution_type_name',
    width: 180
  },
  {
    title: 'Reviewed',
    dataIndex: 'sol_reviewed',
    key: 'sol_reviewed',
    width: 100
  },
  {
    title: 'Approved',
    dataIndex: 'sol_approved',
    key: 'sol_approved',
    width: 100
  },
  {
    title: 'Created By',
    dataIndex: 'sol_created_by',
    key: 'sol_created_by',
    width: 180
  },
  {
    title: 'Created On',
    dataIndex: 'sol_created_on',
    key: 'sol_created_on',
    width: 120
  },
  {
    title: 'Reviewer',
    dataIndex: 'reviewer_name',
    key: 'reviewer_name',
    width: 180
  },
  {
    title: 'Approver',
    dataIndex: 'approver_name',
    key: 'approver_name',
    width: 180
  },
  {
    title: 'Industry',
    dataIndex: 'ind_name',
    key: 'ind_name',
    width: 150
  },
  {
    title: 'Module',
    dataIndex: 'mod_name',
    key: 'mod_name',
    width: 120
  },
  {
    title: 'Category',
    dataIndex: 'cat_name',
    key: 'cat_name',
    width: 120
  },
  {
    title: 'Task Description',
    dataIndex: 'task_description',
    key: 'task_description',
    width: 300,
    render: (items: string[]) => (
      <>
        {items?.map((item, index) => (
          <div key={index}>
            <strong>{index + 1}.</strong> {stripHtmlTags(String(item ?? '-'))}
          </div>
        ))}
      </>
    )
  },
  {
    title: 'Task Type',
    dataIndex: 'task_type_name',
    key: 'task_type_name',
    width: 250,
    render: renderValues
  },
  {
    title: 'Task Status',
    dataIndex: 'task_status_name',
    key: 'task_status_name',
    width: 150,
    render: renderValues
  },
  {
    title: 'Task Owner',
    dataIndex: 'task_owner_name',
    key: 'task_owner_name',
    width: 250,
    render: renderValues
  },
  {
    title: 'Task Due Date',
    dataIndex: 'task_due_date',
    key: 'task_due_date',
    width: 150,
    render: renderValues
  },
  {
    title: 'Task Created By',
    dataIndex: 'task_created_by',
    key: 'task_created_by',
    width: 250,
    render: renderValues
  },
  {
    title: 'Task Created On',
    dataIndex: 'task_created_on',
    key: 'task_created_on',
    width: 150,
    render: renderValues
  },
  {
    title: 'Task Owner Notified',
    dataIndex: 'task_owner_notified',
    key: 'task_owner_notified',
    width: 180,
    render: renderValues
  }
];

export const GAPS_FILTER_COLUMNS = [
  {
    title: 'BRU Value',
    dataIndex: 'bru_value',
    key: 'bru_value',
    width: 250,
    render: (text: string) => <div>{stripHtmlTags(text)}</div>
  },
  {
    title: 'Gap Description',
    dataIndex: 'gap_description',
    key: 'gap_description',
    width: 250,
    render: (text: string) => <div>{stripHtmlTags(text)}</div>
  },
  {
    title: 'Due Date',
    dataIndex: 'gap_due_date',
    key: 'gap_due_date',
    width: 120
  },
  {
    title: 'Closed',
    dataIndex: 'gap_closed',
    key: 'gap_closed',
    width: 80
  },
  {
    title: 'Created By',
    dataIndex: 'gap_created_by',
    key: 'gap_created_by',
    width: 180
  },
  {
    title: 'Created On',
    dataIndex: 'gap_created_on',
    key: 'gap_created_on',
    width: 120
  },
  {
    title: 'Priority',
    dataIndex: 'gap_priority_name',
    key: 'gap_priority_name',
    width: 100
  },
  {
    title: 'Source',
    dataIndex: 'gap_source_name',
    key: 'gap_source_name',
    width: 100
  },
  {
    title: 'Owner',
    dataIndex: 'gap_owner_name',
    key: 'gap_owner_name',
    width: 180
  },
  {
    title: 'Industry',
    dataIndex: 'ind_name',
    key: 'ind_name',
    width: 150
  },
  {
    title: 'Module',
    dataIndex: 'mod_name',
    key: 'mod_name',
    width: 120
  },
  {
    title: 'Category',
    dataIndex: 'cat_name',
    key: 'cat_name',
    width: 120
  }
];

export const GAPS_EVIDENCES_COLUMNS = [
  {
    title: 'Gap ID',
    dataIndex: 'gapId',
    key: 'gapId',
    width: 100
  },
  {
    title: 'Gap Description',
    dataIndex: 'gapDescription',
    key: 'gapDescription',
    width: 250
  },
  {
    title: 'Risk Level',
    dataIndex: 'riskLevel',
    key: 'riskLevel',
    width: 120
  },
  {
    title: 'Evidence Type',
    dataIndex: 'evidenceType',
    key: 'evidenceType',
    width: 150
  },
  {
    title: 'Evidence Description',
    dataIndex: 'evidenceDescription',
    key: 'evidenceDescription',
    width: 250
  },
  {
    title: 'Evidence Status',
    dataIndex: 'evidenceStatus',
    key: 'evidenceStatus',
    width: 130
  },
  {
    title: 'Validation Date',
    dataIndex: 'validationDate',
    key: 'validationDate',
    width: 130
  },
  {
    title: 'Validator',
    dataIndex: 'validator',
    key: 'validator',
    width: 120
  }
];

export const AUDIT_FINDINGS_FILTER_COLUMNS = [
  {
    title: 'BRU Value',
    dataIndex: 'bru_value',
    key: 'bru_value',
    width: 250,
    render: (text: string) => <div>{stripHtmlTags(text)}</div>
  },
  {
    title: 'Audit Finding Description',
    dataIndex: 'audit_finding_description',
    key: 'audit_finding_description',
    width: 250,
    render: (text: string) => <div>{stripHtmlTags(text)}</div>
  },
  {
    title: 'Due Date',
    dataIndex: 'afg_due_date',
    key: 'afg_due_date',
    width: 120
  },
  {
    title: 'Closed',
    dataIndex: 'afg_closed',
    key: 'afg_closed',
    width: 80
  },
  {
    title: 'Created By',
    dataIndex: 'afg_created_by',
    key: 'afg_created_by',
    width: 180
  },
  {
    title: 'Created On',
    dataIndex: 'afg_created_on',
    key: 'afg_created_on',
    width: 120
  },
  {
    title: 'Priority',
    dataIndex: 'afg_priority_name',
    key: 'afg_priority_name',
    width: 100
  },
  {
    title: 'Source',
    dataIndex: 'afg_source_name',
    key: 'afg_source_name',
    width: 120
  },
  {
    title: 'Owner',
    dataIndex: 'afg_owner_name',
    key: 'afg_owner_name',
    width: 180
  },
  {
    title: 'Industry',
    dataIndex: 'ind_name',
    key: 'ind_name',
    width: 150
  },
  {
    title: 'Module',
    dataIndex: 'mod_name',
    key: 'mod_name',
    width: 120
  },
  {
    title: 'Category',
    dataIndex: 'cat_name',
    key: 'cat_name',
    width: 120
  }
];
